import { type ReactElement } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { HelpCenterPage } from "../HelpCenter/Page";
import { HELP_CENTER_PATH } from "../HelpCenter/paths";
import { NotFoundPage } from "../lib";

export function AppV2PrivateRoutes(): ReactElement {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}/${HELP_CENTER_PATH}`}>
        <HelpCenterPage />
      </Route>
      <Route exact path={match.url}>
        <div>This is a private route from appV2</div>
      </Route>
      <Route path="*">
        <NotFoundPage />
      </Route>
    </Switch>
  );
}
